export const updateWishlist = async () => {
    const wishlist = getWishlist();
    const wishListCountElement = document.querySelectorAll('#productsCount');

    wishlistProducts.innerHTML = '';
    updateProductsCount(wishlist.length, wishListCountElement);

    if (wishlist.length === 0) return;
    try {
        const { url } = ajax;
        const formData = new FormData();
        formData.append('action', 'update_wishlist');
        formData.append('product_ids', JSON.stringify(wishlist));

        const req = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        if (!req.ok) throw new Error('Błąd podczas ładowania danych produktów');

        const response = await req.json();

        if (response.success) {
            wishlistProducts.innerHTML += `${response.data.html}`;
            if (!wishListCountElement) return;
            wishListCountElement.forEach(text => {
                text.textContent = `(${response.data.count})`;
            });
        }
    } catch (error) {
        console.error('Error:', error);
    }
};

export const getWishlist = () => {
    const wishlistKey = 'wishlist'; // localStorage key
    return JSON.parse(localStorage.getItem(wishlistKey)) || [];
};

export const clearWishlist = key => {
    localStorage.setItem(key, JSON.stringify([]));
    updateWishlist();
};

export const updateProductsCount = (wishlistCount, wishListCountElement) => {
    wishListCountElement.forEach(count => {
        count.textContent = `(${wishlistCount})`;
    });
};
